import { createApiSlice } from "@common";
import {
  CURD_INQUIRY_TYPE
} from "@routes";

// Define the API config array
const apiConfig = [
  {
    name: "addInquiryType",
    method: "post",
    url: CURD_INQUIRY_TYPE,
    stateKey: "message",
  },
  {
    name: "getInquiryType",
    method: "get",
    url: CURD_INQUIRY_TYPE,
    stateKey: "data",
  },
  {
    name: "updateInquiryType",
    method: "put",
    url: CURD_INQUIRY_TYPE,
    stateKey: "message",
  },
  {
    name: "deleteInquiryType",
    method: "delete",
    url: CURD_INQUIRY_TYPE,
    stateKey: "message",
  },
];

// Define custom reducers and their initial state
const customReducers = {
  initialState: {
    data: [],
    additionalData: [],
  },
  reducers: {
    setAdditionalData: (state, action) => {
      state.additionalData = action.payload;
    },
  },
  extraReducers: {
    // Example of custom extra reducer
    someCustomAction: (state, action) => {
      // Custom reducer logic
    },
  },
};

// Generate the slice, thunks, and actions using the utility function
const { slice, thunks, actions } = createApiSlice(
  "inquiryType",
  apiConfig,
  customReducers,
);
const inquiryTypeSlice = slice;
// Export the slice's reducer
export default inquiryTypeSlice.reducer;

// Destructure and export thunks directly from thunksExports
export const {
  addInquiryType,
  getInquiryType,
  updateInquiryType,
  deleteInquiryType
} = thunks;

// Destructure and export actions directly from actionsExports
export const { rowSelect } =
  actions;
